import React, {useEffect, useRef} from "react";
import {inject, observer} from "mobx-react";
//local
import {Preloader} from "components/Preloader";
import {MAIN_PAGE} from "constants/routes.const";
import {LOGIN_LINK_FAILED} from "constants/auth.const";
import {setSessionStorage} from "helpers/storage";

// One-time login link from support: /login-link#<token>. The token is taken out of the address
// at once, then a full reload to the start page so no data of an earlier login stays in the stores.
const LoginLinkPage = inject("store")(
  observer(({store: {auth}}) => {
    const started = useRef(false); // the effect runs twice in StrictMode, the link works only once

    useEffect(() => {
      if (started.current) return;
      started.current = true;
      const token = window.location.hash.slice(1);
      window.history.replaceState({}, "", window.location.pathname);
      const login = token ? auth.loginWithLink(token) : Promise.reject();
      login
        .catch(() => setSessionStorage(LOGIN_LINK_FAILED, "1"))
        .finally(() => window.location.replace(MAIN_PAGE));
    }, [auth]);

    return <Preloader />;
  })
);

export default LoginLinkPage;
